// Shared strings: user menu (the navbar labels stay fixed English in every language). Keys are read as $t('common.<key>').
export default {
  en: {
    loading: 'Loading…',
    menu: {
      title: 'Display settings',
      language: 'Language',
      orderHist: 'Order Hist',
      orderHistOld: 'Classic',
      orderHistNew: 'New',
      orderHistExp: 'Exp',
      orderHistExp2: 'Experimental 2',
      orderHistOldTitle: 'Original Order History page',
      orderHistNewTitle: 'Redesigned Order History page',
      orderHistExpTitle: 'Experimental Order History page, for trying changes',
      orderHistExp2Title: 'The new Order History page with the Note LLM (DeepSeek standard notes)',
      nav: 'Menu',
      navSide: 'Left',
      navTop: 'Top',
      textSize: 'Text size',
      sizeSmall: 'Small',
      sizeDefault: 'Default',
      sizeLarge: 'Large',
      sizeXLarge: 'Extra large',
      colorTheme: 'Color theme',
      custom: 'Custom',
      customTitle: 'Pick any colour',
      style: 'Style',
      styleOff: 'Off',
      styleOnLabel: 'On',
      styleLevel_light: 'Light',
      styleLevel_calm: 'Calm',
      style_sand: 'Sand',
      style_sage: 'Sage',
      style_mist: 'Mist',
      style_lilac: 'Lilac',
      style_stone: 'Stone',
      style_peach: 'Peach',
      styleCustom: 'Your own colours',
      styleColor_paper: 'Page',
      styleColor_surface: 'Panels',
      styleColor_ink: 'Text',
      styleColor_line: 'Outlines',
      styleLow: 'Low contrast: harder to read',
      styleHint: 'Matte colours instead of bright white, darker text, clearer outlines and less motion. Change any colour to make the style your own.',
      note: 'Saved to your account: the same on any computer you sign in on.',
    },
  },
  vi: {
    loading: 'Đang tải…',
    menu: {
      title: 'Cài đặt hiển thị',
      language: 'Ngôn ngữ',
      orderHist: 'Order Hist',
      orderHistOld: 'Cũ',
      orderHistNew: 'Mới',
      orderHistExp: 'Thử nghiệm',
      orderHistExp2: 'Experimental 2',
      orderHistOldTitle: 'Giao diện Order Hist cũ',
      orderHistNewTitle: 'Giao diện Order Hist mới',
      orderHistExpTitle: 'Giao diện Order Hist thử nghiệm, để thử các thay đổi',
      orderHistExp2Title: 'Order Hist mới có Note LLM (ghi chú chuẩn bằng DeepSeek)',
      nav: 'Thanh menu',
      navSide: 'Bên trái',
      navTop: 'Trên cùng',
      textSize: 'Cỡ chữ',
      sizeSmall: 'Nhỏ',
      sizeDefault: 'Mặc định',
      sizeLarge: 'Lớn',
      sizeXLarge: 'Rất lớn',
      colorTheme: 'Màu giao diện',
      custom: 'Tuỳ chọn',
      customTitle: 'Chọn màu bất kỳ',
      style: 'Kiểu màu',
      styleOff: 'Tắt',
      styleOnLabel: 'Bật',
      styleLevel_light: 'Nhẹ',
      styleLevel_calm: 'Dịu',
      style_sand: 'Cát',
      style_sage: 'Lá',
      style_mist: 'Sương',
      style_lilac: 'Tím',
      style_stone: 'Đá',
      style_peach: 'Đào',
      styleCustom: 'Màu của bạn',
      styleColor_paper: 'Nền trang',
      styleColor_surface: 'Bảng',
      styleColor_ink: 'Chữ',
      styleColor_line: 'Viền',
      styleLow: 'Độ tương phản thấp: khó đọc',
      styleHint: 'Màu trầm thay cho trắng chói, chữ đậm hơn, viền rõ hơn và ít chuyển động. Đổi màu bất kỳ để thành kiểu của riêng bạn.',
      note: 'Lưu theo tài khoản: giống nhau trên mọi máy bạn đăng nhập.',
    },
  },
}
